import {
  Grid,
} from '@mui/material';
import { CellTitle } from '../Styles/TeamTabStyles';

type Props = {
  title: string | JSX.Element,
  menu: JSX.Element | null
};

const TeamTabMobileHeader = ({ title, menu }: Props) => {
  const renderTitle = () => {
    switch (typeof title) {
      case 'string':
        return (
          <CellTitle fontSize={16}>
            {title}
          </CellTitle>
        );
      default:
        return title;
    }
  };

  return (
    <Grid
      container
      className="mobile-table-row-header"
      sx={{
        minHeight: '42px',
        padding: '0px 0px 8px',
      }}
    >
      <Grid
        item
        xs={10}
        sx={{
          alignItems: 'center',
        }}
      >
        {renderTitle()}
      </Grid>
      <Grid
        item
        xs={2}
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'flex-start',
        }}
      >
        {menu}
      </Grid>
    </Grid>
  );
};

export default TeamTabMobileHeader;
